import {
  InstagramUrlSchema,
  FacebookUrlSchema,
  LinkedInUrlSchema,
  TwitterUrlSchema,
  TikTokUrlSchema,
} from '@mfw/common/ui/dtos';
import { z } from 'zod';

export const ApiSocialMediaLinkEnum = z.enum([
  'FACEBOOK',
  'INSTAGRAM',
  'LINKEDIN',
  'TWITTER',
  'TIKTOK',
  'YOUTUBE',
]);

export const ApiSocialMediaSchema = z.object({
  type: ApiSocialMediaLinkEnum.optional(),
  url: z.string().optional().nullable().nullish().or(z.literal('')),
});

export type ApiSocialMediaLink = z.infer<typeof ApiSocialMediaSchema>;
export type ApiSocialMedia = z.infer<typeof ApiSocialMediaSchema>;

/**
 * FE schemas and types
 */
export const UiSocialMediaLinkEnum = ApiSocialMediaLinkEnum;
export const UiSocialMediaSchema = ApiSocialMediaSchema.superRefine(
  (item, ctx) => {
    if (item.type === 'FACEBOOK' && item.url) {
      const result = FacebookUrlSchema.safeParse(item.url);
      if (!result.success) {
        result.error.errors.forEach((err) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: err.message, // Reuse the existing error message
            path: ['url'],
          });
        });
      }
    }
    if (item.type === 'INSTAGRAM' && item.url) {
      const result = InstagramUrlSchema.safeParse(item.url);
      if (!result.success) {
        result.error.errors.forEach((err) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: err.message, // Reuse the existing error message
            path: ['url'],
          });
        });
      }
    }
    if (item.type === 'TWITTER' && item.url) {
      const result = TwitterUrlSchema.safeParse(item.url);
      if (!result.success) {
        result.error.errors.forEach((err) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: err.message, // Reuse the existing error message
            path: ['url'],
          });
        });
      }
    }
    if (item.type === 'LINKEDIN' && item.url) {
      const result = LinkedInUrlSchema.safeParse(item.url);
      if (!result.success) {
        result.error.errors.forEach((err) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: err.message, // Reuse the existing error message
            path: ['url'],
          });
        });
      }
    }
    if (item.type === 'TIKTOK' && item.url) {
      const result = TikTokUrlSchema.safeParse(item.url);
      if (!result.success) {
        result.error.errors.forEach((err) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: err.message, // Reuse the existing error message
            path: ['url'],
          });
        });
      }
    }
  },
);
export type UiSocialMediaLinkEnum = z.infer<typeof UiSocialMediaLinkEnum>;
export type UiSocialMedia = z.infer<typeof UiSocialMediaSchema>;
